import { fetchApi } from "../utils/fetchApi";

export function fetchCarInfoDetails({ filter = {}, options = {} }) {
  return fetchApi({ url: `carinfodetails`, filter: {}, options });
}

